import type { HTMLAttributes } from "react";
import { cn } from "./cn";

export type Tone = "neutral" | "success" | "danger" | "warning" | "accent" | "info";

const tones: Record<Tone, string> = {
  neutral: "bg-surface-sunken text-secondary border-border",
  success: "bg-success-soft text-[#2f6b21] border-success/40",
  danger: "bg-danger-soft text-[#a52620] border-danger/40",
  warning: "bg-warning-soft text-[#7a6d00] border-warning/60",
  accent: "bg-accent-soft text-[#0a6d99] border-accent/50",
  info: "bg-info-soft text-[#075985] border-info/40",
};

export function Badge({ className, tone = "neutral", ...rest }: HTMLAttributes<HTMLSpanElement> & { tone?: Tone }) {
  return (
    <span
      data-tone={tone}
      className={cn("inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium", tones[tone], className)}
      {...rest}
    />
  );
}
